export enum PlatformConfigCode {
  ENABLE_BA_AI = 'enable_ba_ai',
  ENABLE_BA_SAVE_SC = 'enable_ba_save_sc',
  ASSET_LIBRARY_BUTTON = 'asset_library_button',
  STUDIO_MENU = 'studio_menu',
  LIBRARY_LOADING = 'library_loading',
  INTEGRATION_SETTING = 'integration_setting',
  ANALYTICS_TREND = 'analytics_trend',
  ADMIN_AI_FEATURE = 'admin_ai_feature',
  LIBRARY_QUICK_LOAD = 'library_quick_load',
  VERSION_HISTORY = 'version_history',
  NOMINATE_COLLEAGUE = 'nominate_colleague',
  MY_WORKSPACE_SETTINGS = 'my_workspace_settings',
  INBOUND_LOOP_CAMPAIGN = 'inbound_loop_campaign',
  STUDIO_EDITOR = 'studio_editor',
  EMBED_ANALYTICS = 'embed_analytics',
  FEATURE_PACKAGE = 'feature_package',
  EMBED_ADV_POSTING = 'enable_adv_posting',
  ENABLE_ADVOCACY = 'enable_advocacy',
  DISABLE_AI_FEATURES = 'disable_ai_features',
}

export interface IPlatformConfig {
  id: string;
  name: string;
  enabled: boolean;
  value: any;
  created_at: string;
  updated_at: string;
}
